export const isTraqify = () => {
  return window.location.hostname.includes("traqify");
};
